// Payment Configuration
export const CLOUDPAYMENTS_PUBLIC_ID = 'pk_a0f648514746b0c69774378b2a1ef';
export const PAYMENT_CURRENCY = 'RUB';

// Music styles
export const MUSIC_STYLES = [
    {
        id: 'pop',
        name: 'Поп',
        icon: '🎤',
        sampleUrl: 'https://storage.yandexcloud.net/selebrus-page-assets/Examples/music/pop.mp3'
    },
    {
        id: 'rock',
        name: 'Рок',
        icon: '🎸',
        sampleUrl: 'https://storage.yandexcloud.net/selebrus-page-assets/Examples/music/rock.mp3'
    },
    {
        id: 'hip-hop',
        name: 'Хип-хоп',
        icon: '🎧',
        sampleUrl: 'https://storage.yandexcloud.net/selebrus-page-assets/Examples/music/hip-hop.mp3'
    },
    {
        id: 'ballad',
        name: 'Баллада',
        icon: '🎹',
        sampleUrl: 'https://storage.yandexcloud.net/selebrus-page-assets/Examples/music/ballada.mp3'
    },
    {
        id: 'electronic',
        name: 'Электронная',
        icon: '🎛️',
        sampleUrl: 'https://storage.yandexcloud.net/selebrus-page-assets/Examples/music/electro.mp3'
    },
    {
        id: 'jazz',
        name: 'Джаз',
        icon: '🎷',
        sampleUrl: 'https://storage.yandexcloud.net/selebrus-page-assets/Examples/music/jazz.mp3'
    },
];

// Voice types
export const MUSIC_VOICES = [
    {id: 'male', name: 'Мужской', icon: '👨'},
    {id: 'female', name: 'Женский', icon: '👩'},
    {id: 'mixed', name: 'Смешанный', icon: '👫'},
];

// Music occasions (reuse from video)
export const MUSIC_OCCASIONS = [
    {id: 'birthday', name: 'День рождения', icon: '🎂'},
    {id: 'wedding', name: 'Свадьба', icon: '💒'},
    {id: 'anniversary', name: 'Годовщина', icon: '💍'},
    {id: 'congrats', name: 'Поздравление', icon: '🎉'},
    {id: 'promotion', name: 'Повышение', icon: '🏆'},
    {id: 'other', name: 'Другое', icon: '✨'},
];

// Generation status texts
export const GENERATION_STATUS_TEXTS = [
    'Звезда в шоке и начала учить текст…',
    'Звезда надевает своё лучшее белье для ролика',
    'Звезда хочет просто лежать на диване,\nно мы заставляем ее работать',
    'Свет. Камера. Мотор. Уже выехал за селебом.',
    'Звезда повторяет текст в такси',
    'Немного волнуется…потеет ради вас',
    'Осталось немного, генерация уже давно идет',
    'Сотни компуктеров делают вам видео',
    'Почему морские звезды не селебрити?',
    'Скоро всё будет готово',
    'Соединяем видеоряд и озвучку',
    'Сохраняем файл на серверах',
    'К звезде выстроилась очередь для пофоткаться',
    'Мы тоже ждём…',
    'Ща, уже скоро',
    'Видео отправляется…',
    'Спасибо, что были вместе с этим текстом.'
];
